var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{on:{"change":_vm.change}},_vm._l((_vm.items),function(item,idx){return _c('option',{key:idx,domProps:{"value":item.value,"selected":_vm.value == item.value}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }